import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import Home from "./components/Home";
import HeatMap from "./components/HeatMap";
import ChargeDrainPage from './pages/ChargeDrainPage';
import TemperatureAnalysis from './pages/TemperatureAnalysis';
import DeviceOutages from './components/DeviceOutages';
import LocationHeatmapPage from "./components/LocationHeatmapPage";
import AlertsDashboard from "./pages/AlertsDashboard";
import AlertDetails from "./components/AlertDetails";
import SpeedTestPage from './pages/SpeedTestPage';
import SpeedTestDashboard from './components/SpeedTestDashboard';
import AnalyticsQueryBot from './components/AnalyticsQueryBot';
import ComparativeAnalyticsPage from './pages/ComparativeAnalyticsPage';
import DeviceInfoCompact from './pages/DeviceInfoCompact';
import YardDeviceDetailsPage from './pages/YardDeviceDetailsPage';
import YardLayoutPage from './pages/YardLayoutPage';
import YardTravelMapPage from './pages/YardTravelMapPage';
import SpeedTestAuditPage from './pages/SpeedTestAuditPage';
import SpeedTestGroupsPage from './pages/SpeedTestGroupsPage';
import OktaLoginPage from './okta/frontend/OktaLoginPage';
import OktaLoginCallbackPage from './okta/frontend/OktaLoginCallbackPage';
import { AnalyticsBotProvider } from "./context/AnalyticsBotContext";
import { PortalAccessProvider, usePortalAccess } from "./context/PortalAccessContext";

function NotFoundPage() {
  return (
    <div className="p-10 text-center">
      <h1 className="text-3xl font-bold mb-2">404</h1>
      <p className="text-gray-600">Page not found.</p>
    </div>
  );
}

/** Routes + shell shown only after portal email / scope is established */
function AppWithShell() {
  return (
    <>
      <Header />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/HeatMap" element={<HeatMap />} />
        <Route path="/device/:androidId/charge-drain" element={<ChargeDrainPage />} />
        <Route path="/temperature/:androidId" element={<TemperatureAnalysis />} />
        <Route path="/device-outages" element={<DeviceOutages />} />
        <Route path="/speedtest-dashboard" element={<SpeedTestDashboard />} />
        <Route path="/heatmap" element={<LocationHeatmapPage />} />
        <Route path="/alerts" element={<AlertsDashboard />} />
        <Route path="/alerts/:id" element={<AlertDetails />} />
        <Route path="/comparative-analytics" element={<ComparativeAnalyticsPage />} />
        <Route path="/device-info-compact" element={<DeviceInfoCompact />} />
        <Route path="/speed-test-audit" element={<SpeedTestAuditPage />} />
        <Route path="/yard/:yardNumber/devices" element={<YardDeviceDetailsPage />} />
        <Route path="/yard/:yardNumber/layout" element={<YardLayoutPage />} />
        <Route path="/yard-travel-map" element={<YardTravelMapPage />} />
        <Route path="/speed-test-groups" element={<SpeedTestGroupsPage />} />
        <Route path="/portal-access" element={<OktaLoginPage />} />
        <Route path="/device/:androidId/speed-test" element={<SpeedTestPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <AnalyticsQueryBot />
    </>
  );
}

function AppGate() {
  const { access } = usePortalAccess();
  const hasAccess = Boolean(access?.email);

  if (!hasAccess) {
    return (
      <>
        <Header />
        <Routes>
          <Route path="/login/callback" element={<OktaLoginCallbackPage />} />
          <Route path="*" element={<OktaLoginPage />} />
        </Routes>
      </>
    );
  }

  return <AppWithShell />;
}

function App() {
  return (
    <AnalyticsBotProvider>
      <PortalAccessProvider>
        <Router>
          <AppGate />
        </Router>
      </PortalAccessProvider>
    </AnalyticsBotProvider>
  );
}

export default App;
